import { useEffect, useState } from "react"
import ProductCard2 from "./ProductCard2"

function FeaturedProductList({ updated }) {
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    const controller = new AbortController()

    const loadData = async () => {
      try {
        setLoading(true)
        setError(false)

        // Ask the server for featured products directly; filtering a page of
        // the newest products dropped featured ones once the catalog grew.
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/products/filter`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            // One featured staple per category
            body: JSON.stringify({ filters: { featured: true }, limit: 20 }),
            signal: controller.signal,
          },
        )

        if (!res.ok) throw new Error("Failed to fetch products")

        const data = await res.json()

        // Show them in the same order as the homepage categories
        const cats = await fetch(`${process.env.REACT_APP_API_URL}/categories`, {
          signal: controller.signal,
        })
          .then((r) => (r.ok ? r.json() : []))
          .catch(() => [])
        const order = (Array.isArray(cats) ? cats : []).map((c) => c.name)
        const rank = (p) => (order.includes(p.category) ? order.indexOf(p.category) : order.length)

        setProducts([...(data.products || [])].sort((a, b) => rank(a) - rank(b)))
      } catch (err) {
        if (err.name !== "AbortError") {
          console.error("FeaturedProductList error:", err)
          setError(true)
          setProducts([])
        }
      } finally {
        setLoading(false)
      }
    }

    loadData()

    return () => controller.abort()
  }, [updated])

  /* ---------------------------
     UI STATES
  --------------------------- */

  if (loading) {
    return (
      <div className="text-center mb-5">
        <h2 className="lead fs-4 text-dark">Loading...</h2>
        <div className="spinner-border text-primary fs-3 mt-3" />
      </div>
    )
  }

  if (error) {
    return (
      <div className="text-center">
        <h2 className="lead fs-4 text-danger">
          Failed to load featured products
        </h2>
      </div>
    )
  }

  if (products.length === 0) {
    return (
      <div className="text-center">
        <h2 className="lead fs-4 text-muted">
          No featured products available.
        </h2>
      </div>
    )
  }

  /* ---------------------------
     UI
  --------------------------- */

  return (
    <section className="container-fluid col-11 mt-4">
      <h1 className="home-title text-center mb-3">FEATURED PRODUCTS</h1>

      {/* One row of cards; swipes sideways when they don't all fit */}
      <div className="product-row">
        {products.map((p) => (
          <ProductCard2 key={p.product_id} product={p} />
        ))}
      </div>
    </section>
  )
}

export default FeaturedProductList
